import React, { useState } from "react";
import DragDropZone from "./DragDropZone";
import ParentModal from "./SupportedFeaturesModal";
import "./Estimator.css";
import "./UploadPage.css";

interface UploadPageProps {
    file: File | null;
    setFile: (file: File | null) => void;
    onFilesSelected?: (files: File[]) => void;
    onSubmit: () => void;
    onCreateFromScratch: () => void;
}

const UploadPage: React.FC<UploadPageProps> = ({ file, setFile, onFilesSelected, onSubmit, onCreateFromScratch }) => {
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);

    return (
        <>
            <div className="supported-features">
                <p>Please view our supported features before submitting</p>
                <button className="animated-button modal-button" onClick={() => setShowModal(true)}>
                    <span>Supported Features</span>
                    <span></span>
                </button>
            </div>

            <ParentModal showModal={showModal} handleCloseModal={handleCloseModal} />

            <div className="drag-drop">
                <DragDropZone
                    file={file}
                    allowedFileExtensions={[".dwg", ".dxf"]}
                    setFile={setFile}
                    onFilesSelected={onFilesSelected}
                />
                <div className="upload-container">
                    {file && (
                        <div className="submit-button-container">
                            <button className="animated-button" onClick={onSubmit}>
                                <span>Submit File</span>
                                <span></span>
                            </button>
                        </div>
                    )}
                </div>
                <div className="new-list-container">
                    {!file && (
                    <button className="animated-button" onClick={onCreateFromScratch}>
                        <span>Create From Scratch</span>
                        <span></span>
                    </button>
                    )}
                </div>
            </div>
        </>
    );
};

export default UploadPage;
